import { render, staticRenderFns } from "./DisplayAccordionOrderItems.vue?vue&type=template&id=b511dc08&scoped=true&"
import script from "./DisplayAccordionOrderItems.vue?vue&type=script&lang=js&"
export * from "./DisplayAccordionOrderItems.vue?vue&type=script&lang=js&"
import style0 from "./DisplayAccordionOrderItems.vue?vue&type=style&index=0&id=b511dc08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b511dc08",
  null
  
)

export default component.exports